module.exports = __webpack_public_path__ + "static/q6-a87781d2346f5393403e92aaeec1804d.svg";